/**
 * ClinicalNotApprovedBanner — DEPRECATED as of the production-readiness cutover.
 *
 * Governance, security and clinical-workflow reviews are now complete for the
 * launch scope, so the persistent "clinical use not yet approved" banner is
 * intentionally suppressed. We still keep the CSS variable at 0px so any
 * layout code that shifted down for it (fixed headers etc.) keeps working
 * unchanged — headers will simply sit at top:0 as normal.
 *
 * If a future compliance regression means we need to re-surface the warning,
 * revert this file from git rather than adding a fresh banner elsewhere.
 */
import { useEffect } from "react";

export default function ClinicalNotApprovedBanner() {
  useEffect(() => {
    document.documentElement.style.setProperty("--fl-banner-height", "0px");
  }, []);
  return null;
}
